import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b712956"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collecting" }
const _hoisted_2 = { class: "operationCont" }
const _hoisted_3 = { class: "UserManagement-table" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "paginationCont" }

import { reactive, ref, onMounted, onUnmounted, nextTick, watch } from "vue";
import { ElMessage, ElPopconfirm, ElMessageBox } from "element-plus";
import { Search, RefreshRight, CirclePlus } from "@element-plus/icons-vue";
import { getListCompanyInfo } from "@/views/Login/api";

import { getDataCorrPageList } from "./api.js";
import CreateDataCorrDialog from './views/CreateDataCorrDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const pageSizes = ref([10, 20, 50]);
const hasInitialSearch = ref(false);
const calculating = ref(false);
const hasCalculated = ref(false);
const talentArr = ref<any>([]);
const createDialogRef = ref(null);
const calculateTableRows = () => {
    if (calculating.value) return;
    calculating.value = true;

    const tableContainer = document.querySelector('.UserManagement-table');
    if (!tableContainer) {
        calculating.value = false;
        return;
    }

    const allRows = document.querySelectorAll('.el-table__row');
    if (!allRows.length) {
        if (!hasInitialSearch.value) {
            hasInitialSearch.value = true;
            onSearch(false);
        }
        calculating.value = false;
        return;
    }

    // 计算所有行的平均高度
    const totalHeight = Array.from(allRows).reduce((sum, row) => {
        return sum + row.getBoundingClientRect().height;
    }, 0);
    const averageRowHeight = totalHeight / allRows.length;
    
    const tableHeader = document.querySelector('.el-table__header');
    const headerHeight = tableHeader ? tableHeader.getBoundingClientRect().height : 0;
    
    const containerHeight = tableContainer.clientHeight;
    const availableHeight = containerHeight - headerHeight;
    
    // 计算可显示的行数
    const maxRows = Math.floor((availableHeight - 20) / averageRowHeight);
    
    // 向上取整到最近的5的倍数
    const calculatedSize = Math.ceil(maxRows / 5) * 5;

    // 添加合理的最小值和最大值限制
    const minPageSize = 5;
    const maxPageSize = 50;
    const normalizedSize = Math.min(Math.max(calculatedSize, minPageSize), maxPageSize);

    const tolerance = 2;
    if (Math.abs(queryForm.pageSize - normalizedSize) <= tolerance) {
        calculating.value = false;
        return;
    }

    console.log('计算得到的行数---:', {
        containerHeight,
        headerHeight,
        availableHeight,
        averageRowHeight,
        maxRows,
        calculatedSize: normalizedSize
    });

    pageSizes.value = [normalizedSize, normalizedSize * 2, normalizedSize * 3].filter(size => size <= maxPageSize);
    defaultPageSize.value = normalizedSize;
    queryForm.pageSize = normalizedSize;
    
    setTimeout(() => {
        onSearch(true);
        calculating.value = false;
    }, 100);
};
const defaultPageSize = ref(10);

const queryForm = reactive({
    pageIndex: 1,
    pageSize: defaultPageSize.value,
    condition: {
      compCode: '',
      dataCorrectionType: '',
      dimensionValue: '',
      dimensionType: ''
    },
});
const formatDimensionValue = (value: string) => {
    if (!value) return '';
    // 如果值中包含逗号，用<br>标签替换实现换行
    if (value.includes(',')) {
      return value.split(',').map(item => item.trim()).join('<br>');
    }
    return value;
}
const formatDataCorrectionType = (row: any) => {
  switch (row.dataCorrectionType) {
    case 'ADDRESS':
      return '地址';
    case 'PUSH_STATUS':
      return '推送状态';
    case 'IDCARD':
      return '证件号码';
    case 'FARMER_NAME':
      return '农户姓名';
    case 'REGISTER_NO':
      return '登记号';
    default:
      return row.dataCorrectionType;
  }
};
const total = ref<number>(0);
const tableData = ref<any>([]);
const createDialogVisible = ref(false);
const queryFormRef = ref();


const onSearch = (type: boolean) => {
    // 创建一个新的查询对象，移除空字符串值和null值
    const cleanQuery = Object.fromEntries(
        Object.entries(queryForm.condition).filter(([_, v]) => v !== "" && v !== null)
    );
  getDataCorrPageList({ ...queryForm, condition: cleanQuery }).then((res: any) => {
    const { items, totalSize } = res;
    total.value = Number(totalSize);
    tableData.value = items;
  }).catch((error) => {
    console.error("Error fetching dataCorrection page:", error);
    ElMessage.error("获取数据失败，请重试");
  });
};
const getListCompanyInfos = () => {
  getListCompanyInfo().then((res: any) => {
    console.log(res);
    talentArr.value = res;
  });
};
const handleReset = () => {
    hasCalculated.value = false;
    queryForm.condition.compCode = '';
    queryForm.condition.dataCorrectionType = '';
    queryForm.condition.dimensionValue = '';
    queryForm.condition.dimensionType = '';
};

const handleSizeChange = (val: number) => {
    queryForm.pageSize = val;
    onSearch(true);
};
const handleCurrentChange = (val: number) => {
    queryForm.pageIndex = val;
    onSearch(false);
};
const openCreateDialog = () => {
  console.log("进入dialog")
    createDialogVisible.value = true;
    if (createDialogRef.value) {
      createDialogRef.value.clearAllValidations?.();
    }
};

const handleCreated = () => {
    ElMessage.success('数据修正成功');
    onSearch(true);
};

onMounted(() => {
    nextTick(() => {
        calculateTableRows();
    });
    getListCompanyInfos();
    const debouncedCalculate = debounce(calculateTableRows, 200);
    window.addEventListener('resize', debouncedCalculate);
});
watch(tableData, () => {
    if (tableData.value.length > 0 && !hasCalculated.value) {
        nextTick(() => {
            calculateTableRows();
            hasCalculated.value = true;
        });
    }
}, { immediate: false });
onUnmounted(() => {
    window.removeEventListener('resize', calculateTableRows);
});
const debounce = (fn: Function, delay: number) => {
    let timer: any = null;
    return function (this: any, ...args: any[]) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(this, args);
        }, delay);
    };
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          inline: true,
          model: queryForm,
          class: "demo-form-inline",
          ref_key: "queryFormRef",
          ref: queryFormRef
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "租户" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: queryForm.condition.compCode,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.condition.compCode) = $event)),
                      placeholder: "请选择",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(talentArr.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.compCode,
                            label: item.compName,
                            value: item.compCode
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "数据修正类型" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      ref: "selectRef",
                      modelValue: queryForm.condition.dataCorrectionType,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.condition.dataCorrectionType) = $event)),
                      placeholder: "请选择",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "地址",
                          value: "ADDRESS"
                        }),
                        _createVNode(_component_el_option, {
                          label: "推送状态",
                          value: "PUSH_STATUS"
                        }),
                        _createVNode(_component_el_option, {
                          label: "证件号码",
                          value: "IDCARD"
                        }),
                        _createVNode(_component_el_option, {
                          label: "农户姓名",
                          value: "FARMER_NAME"
                        }),
                        _createVNode(_component_el_option, {
                          label: "登记号",
                          value: "REGISTER_NO"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "维度" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: queryForm.condition.dimensionValue,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.condition.dimensionValue) = $event)),
                      placeholder: "请输入",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      icon: _unref(Search),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (onSearch(true)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("查询")
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    _createVNode(_component_el_button, {
                      type: "",
                      icon: _unref(RefreshRight),
                      onClick: handleReset
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("重置")
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      icon: _unref(CirclePlus),
                      onClick: openCreateDialog
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("数据修正")
                      ]),
                      _: 1
                    }, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_table, {
          data: tableData.value,
          border: "",
          style: {"width":"100%"},
          height: "100%",
          onRowMounted: calculateTableRows
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "index",
              label: "序号",
              width: "60",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "compName",
              label: "租户",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "dataCorrectionType",
              label: "数据修正类型",
              align: "center",
              formatter: formatDataCorrectionType
            }),
            _createVNode(_component_el_table_column, {
              prop: "dimensionType",
              label: "维度类型",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "dimensionValue",
              width: "260",
              label: "维度值",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", {
                  innerHTML: formatDimensionValue(scope.row.dimensionValue),
                  style: {"text-align":"center"}
                }, null, 8, _hoisted_4)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "beforeCorrectionValue",
              label: "当前数据为",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "afterCorrectionValue",
              label: "修正数据为",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "updatedTime",
              label: "操作时间",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "userName",
              label: "操作人",
              align: "center"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_pagination, {
          background: "",
          layout: "total, sizes, prev, pager, next",
          "page-sizes": pageSizes.value,
          total: total.value,
          "current-page": queryForm.pageIndex,
          "onUpdate:current-page": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.pageIndex) = $event)),
          "page-size": queryForm.pageSize,
          "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.pageSize) = $event)),
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["page-sizes", "total", "current-page", "page-size"])
      ])
    ]),
    _createVNode(CreateDataCorrDialog, {
      ref_key: "createDialogRef",
      ref: createDialogRef,
      visible: createDialogVisible.value,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((createDialogVisible).value = $event)),
      onCreated: handleCreated
    }, null, 8, ["visible"])
  ], 64))
}
}

})